import { render, staticRenderFns } from "./NftHolderTable.vue?vue&type=template&id=8f001e64&scoped=true"
import script from "./NftHolderTable.vue?vue&type=script&lang=js"
export * from "./NftHolderTable.vue?vue&type=script&lang=js"
import style0 from "./NftHolderTable.vue?vue&type=style&index=0&id=8f001e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f001e64",
  null
  
)

export default component.exports